import Service from "./Service";
import { FlightOrderEntity } from "../model/Flight";
import { orderService } from "./orderService";
class flightService extends orderService {
  CreateOrder(data: FlightOrderEntity) {
    return this.post<any>(`/FlightOrder/CreateOrderByProduct`, data);
  }
  OrderChange(data: any) {
    return this.post<any>(`/FlightOrder/FlightOrderChange`, data);
  }
  changeSolve(data: any) {
    return this.post<any>(`/flightchange/solve`, data);
  }
  CreateOrderByPreference(data: any) {
    return this.post<any>(`/FlightOrder/CreateOrderByPreference`, data);
  }
  // CheckRepeatOrder(data: FlightOrderEntity) {
  //   return this.post<FlightOrderEntity>(`/FlightOrder/CheckRepeatOrder`, data, {
  //     failTips: false,
  //   });
  // }
  // OrderDetails(UniqueID: string) {
  //   return this.get<any>(`/FlightOrder/OrderDetails?UniqueID=${UniqueID}`);
  // }
  // OrderCancel(id: string) {
  //   return this.get<any>(`/FlightOrder/OrderCancel?UniqueID=${id}`);
  // }
  // RefundJudge(UniqueID: string) {
  //   return this.get<any>(`/FlightOrder/RefundJudge?UniqueID=${UniqueID}`);
  // }
  // CreateAmend(amend: any) {
  //   return this.post<any>(`/FlightOrder/CreateAmend`, amend);
  // }
  // OrderSubmit(UniqueID: string) {
  //   return this.get<any>(`/FlightOrder/OrderSubmit/${UniqueID}`);
  // }
  // UpdateOrderStatus(id: string) {
  //   return this.get<any>(`/FlightOrder/UpdateOrderStatus?UniqueID=${id}`);
  // }
  // OrderRefund(data: any) {
  //   return this.post<any>(`/FlightOrder/OrderRefund`, data);
  // }
  // getReplenishOrderInfomation(data: FlightOrderEntity) {
  //   return this.post<FlightOrderEntity>(`/FlightOrder/ReplenishOrderInfomation`, data);
  // }
 
  // SearchOrders(id: string) {
  //   return this.get<any>(`/FlightOrder/SearchOrders?UniqueID=${id}`);
  // }
  // OrderRefundCancel(id: string) {
  //   return this.get<any>(`/FlightOrder/OrderRefundCancel?UniqueID=${id}`);
  // }
}
export default new flightService("flight", "FlightOrder");
